// tslint:disable:deprecation
import { switchMap, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener } from '@angular/core';
import { HttpServices } from '../services/http.service';
import { SepaForm } from '../models';
import * as config from '../config/config';
import { Observable, Subject, Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { FournisseurType, HttpStatus } from '../models';
import { Address } from '../models/address.model';
import { Params } from '@fortawesome/fontawesome-svg-core';
import { ReferenceService } from '../services/reference.service';
import { ValidationFormService } from '../services/validationForm.service';
import { SignatureState } from '../models/signatureState.model';
import { DomSanitizer } from '@angular/platform-browser';
import { SignatureService } from '../services/signature.service';
import { UserService } from '../services/user.service';
import { faCheckCircle, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons/faCircle';
import { LoaderService } from '../services/loader.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TrackingService } from '../services/tracking.service';

@Component({
  selector: 'fs-sepa-mandate-form',
  styleUrls: ['./sepa-mandate-form.sass'],
  templateUrl: './sepa-mandate-form.component.html',
  encapsulation: ViewEncapsulation.None
})

export class SepaMandateFormComponent implements OnInit, OnDestroy {
  tiersId: number;
  supplierId: number;
  hashSecu: string;
  isOffline: boolean = true;
  sepaMandateForm: FormGroup;
  infosSepa: SepaForm;
  validateErrorsCompany: boolean = false;
  addresses: Array<Address> = [];
  searchTermSubject$ = new Subject<string>();
  searchTerm$ = new Observable<string>();
  fournisseurType = FournisseurType;

  // Statut du Mandat Sepa
  sepaMandateState: SignatureState = null;
  // Statut de la signature électronique du Mandat Sepa
  signatureSepaState: SignatureState = null;

  SignatureState = SignatureState;

  isValidChangePage: boolean = false;
  subscriptionChangePage: Subscription;
  urlOkChangePage: string = '';

  faCheckCircle = faCheckCircle;
  faCircle = faCircle;
  faTimes = faTimes;
  faCheck = faCheck;
  orderId: number;
  orderHash: string;
  isOrderAndSepaSign: boolean = false;
  offlinePageTitle = 'Souscription aux services';

  constructor(private httpServices: HttpServices,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private referenceService: ReferenceService,
    private userService: UserService,
    private router: Router,
    private sanitizer: DomSanitizer,
    public signatureService: SignatureService,
    private ngxSmartModalService: NgxSmartModalService,
    private trackingService: TrackingService) {

    this.subscriptionChangePage = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.urlOkChangePage = event.url;
      }
    });

    let param: Params;
    this.route.params.subscribe(params => param = params);
    this.hashSecu = param['hash-secu'];
    this.supplierId = param['supplier-id'];
    this.tiersId = param['tiers-id'];

    this.route.queryParams.subscribe(qparams => {
      this.orderId = qparams['orderId'];
      this.orderHash = qparams['orderHash'];
    });

    switch (this.route.snapshot.url[0].path) {
      case 'sepa-mandate-sign':
        this.isOffline = false;
        this.tiersId = this.userService.IdTiers;
        break;

      case 'sepa-sign':
        this.isOffline = true;
        if (this.orderId && this.orderHash) {
          this.isOrderAndSepaSign = true;
        }
        break;

      default:
        break;
    }

    this.infosSepa = new SepaForm();

    this.searchTerm$ = this.searchTermSubject$.asObservable();
    this.searchTerm$.pipe(debounceTime(1500), distinctUntilChanged(), switchMap(term => this.getAddresses(term)))
      .subscribe(addresses => this.onGetAddresses(addresses));

    this.buildForm();
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.isValidChangePage) {
      this.ngxSmartModalService.open('sepaFormExitModal');
    }
    return this.isValidChangePage;
  }

  ngOnInit() {
    this.getSepaState();
  }

  ngOnDestroy() {
    this.isValidChangePage = true;
    this.subscriptionChangePage.unsubscribe();
  }

  buildForm(): void {
    this.sepaMandateForm = this.formBuilder.group({
      'RaisonSociale': [this.infosSepa.PayerCompanyName, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]],
      'Adresse': [this.infosSepa.PayerStreetAddress, [Validators.required, Validators.minLength(2), Validators.maxLength(128)]],
      'Ville': [this.infosSepa.PayerCity, [Validators.required, Validators.minLength(2), Validators.maxLength(128)]],
      'Cp': [this.infosSepa.PayerZipCode, [Validators.required, Validators.minLength(4), Validators.maxLength(7)]],
      'Pays': [this.infosSepa.PayerCountry, [Validators.required, Validators.minLength(3), Validators.maxLength(128)]],
      'Nom': [this.infosSepa.PayerLastName, [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
      'Prenom': [this.infosSepa.PayerFirstName, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      'Iban': [this.infosSepa.PayerAccountIBAN, [Validators.required, ValidationFormService.ibanFormatValidator]],
      'Bic': [this.infosSepa.PayerAccountBIC, [Validators.required, Validators.minLength(8), Validators.maxLength(11)]]
    });
  }

  private getSepaState(): void {
    if (this.isOffline) {
      this.getInfoSepaState();
    } else {
      this.getAccessSepaConnect();
    }
  }

  private getAccessSepaConnect() {
    this.loaderService.increaseLoaderCount();

    this.httpServices.get<Response>(this.referenceService.staticReferences.Action[config.ApiKeys.GET_ACCESS_SEPA]
      .replace('{0}', `${this.supplierId}`), () => { })
      .subscribe(
        Response => {
          this.getInfoSepaState();
          this.sepaMandateState = SignatureState.READY_TO_SIGN;
          this.loaderService.decreaseLoaderCount();
        },
        error => {
          this.handleStatusError(error.status);
        }
      );
  }

  private getInfoSepaState() {
    this.loaderService.increaseLoaderCount();

    if (this.isOffline) {
      this.httpServices.getWithoutAuth<SepaForm>(
        this.referenceService.staticReferences.Action[config.ApiKeys.GET_SEPA_STATUS]
          .replace('{0}', this.tiersId).replace('{1}', this.supplierId).replace('{2}', this.hashSecu), SepaForm.extractData)
        .subscribe(
          filledSepa => {
            this.infosSepa = filledSepa;
            this.sepaMandateState = SignatureState.READY_TO_SIGN;
            this.buildForm();
            this.trackingService.pushEvent('financial-sepa_signature');
            this.trackingService.pushPageViewGA4('financial_sepa_signature');
            this.loaderService.decreaseLoaderCount();
          },
          error => {
            this.handleStatusError(error.status);
          }
        );
    } else {
      this.httpServices.get<SepaForm>(
        this.referenceService.staticReferences.Action[config.ApiKeys.GET_SEPA_STATUS_CONNECT].replace('{0}', this.tiersId)
          .replace('{1}', this.supplierId)
        , SepaForm.extractData)
        .subscribe(
          filledSepa => {
            this.infosSepa = filledSepa;
            this.sepaMandateState = SignatureState.READY_TO_SIGN;
            this.buildForm();
            this.trackingService.pushEvent('financial-sepa_signature');
            this.trackingService.pushPageViewGA4('financial_sepa_signature');
            this.loaderService.decreaseLoaderCount();
          },
          error => {
            this.handleStatusError(error.status);
          }
        );
    }
  }

  private handleStatusError(status: HttpStatus) {
    if (status === HttpStatus.CONFLICT) {
      this.sepaMandateState = SignatureState.SIGNED;
    } else if (status === HttpStatus.NOT_FOUND) {
      this.sepaMandateState = SignatureState.NOT_FOUND;
    } else if (status === HttpStatus.INTERNAL_SERVER_ERROR || status === HttpStatus.BAD_REQUEST) {
      this.sepaMandateState = SignatureState.ERROR;
    }
    this.loaderService.decreaseLoaderCount();
  }

  generateSepa() {
    this.isValidChangePage = true;
    this.loaderService.increaseLoaderCount();
    const infoForm = this.getInfoForm();
    // offline mode
    if (this.isOffline) {
      if (this.isOrderAndSepaSign) {
        this.httpServices.postWithoutAuth<SepaForm, any>(
          this.referenceService.staticReferences.Action[config.ApiKeys.POST_SEPA_INFOS].replace('{0}', this.orderId)
            .replace('{1}', this.orderHash), infoForm, () => { }).subscribe(
              () => this.getOrderAndSepaSignUrl()
            );
      } else {
        this.httpServices.postWithoutAuth<SepaForm, any>(
          this.referenceService.staticReferences.Action[config.ApiKeys.POST_SEPA_GENERATE].replace('{0}', this.tiersId).replace('{1}',
            this.supplierId).replace('{2}', this.hashSecu), infoForm, () => { }
        ).subscribe(
          response => {
            this.handleSignSepa(response);
          },
          error => {
            this.handleSignSepaError(error);
          }
        );
      }
    } else { // connected mode
      this.httpServices.post<SepaForm, any>(
        this.referenceService.staticReferences.Action[config.ApiKeys.POST_SEPA_GENERATE].replace('{0}', this.supplierId).replace('/{1}/{2}', ''), infoForm, (ret: any) => { }
      ).subscribe(
        response => {
          this.handleSignSepa(response);
        },
        error => {
          this.handleSignSepaError(error);
        }
      );
    }
  }

  private getOrderAndSepaSignUrl() {
    this.httpServices.getWithoutAuth<any>(this.referenceService.staticReferences.Action[config.ApiKeys.GET_URL_IFRAME_SIGN]
      .replace('{0}', this.orderId).replace('{1}', this.orderHash), () => { }).subscribe(
        response => {
          this.signatureService.setUrlSignatureSepa(this.sanitizer.bypassSecurityTrustResourceUrl(response.UrlEframe));
          this.ngxSmartModalService.open('sepaSignIframeModal');
        },
        error => {
          this.handleSignSepaError(error);
        }
      );
  }

  private handleSignSepa(response: any): void {
    this.signatureService.setUrlSignatureSepa(this.sanitizer.bypassSecurityTrustResourceUrl(response.UrlForSigning));
    this.ngxSmartModalService.open('sepaSignIframeModal');
  }

  private handleSignSepaError(error: any) {
    if (error.status === HttpStatus.CONFLICT) {
      this.signatureSepaState = SignatureState.SIGNED;
    } else if (error.status === HttpStatus.NOT_FOUND) {
      this.signatureSepaState = SignatureState.NOT_FOUND;
    } else if (error.status === HttpStatus.INTERNAL_SERVER_ERROR || error.status === HttpStatus.BAD_REQUEST) {
      this.signatureSepaState = SignatureState.ERROR;
    }
  }

  getAddresses(term: string): Promise<Address[]> {
    const params = [{ 'Key': 'address', 'Value': term }];
    return this.httpServices.getWithoutAuth<Array<Address>>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_ADDRESSES], Address.extractData, params
    ).toPromise();
  }

  onGetAddresses(addresses: Array<Address>) {
    this.addresses = addresses;
    if (this.addresses.length > 0) {
      window.document.addEventListener('mouseup', this.handleClick);
    } else {
      window.document.removeEventListener('mouseup', this.handleClick);
    }
  }

  handleClick(e: any) {
    const isOption = e.target.classList.contains('drop-option');
    if (!isOption) {
      this.addresses = [];
    }
  }

  onAddressSelected(address: Address) {
    this.sepaMandateForm.patchValue({ 'Cp': address.PostalCode });
    this.sepaMandateForm.patchValue({ 'Ville': address.City });
    this.sepaMandateForm.patchValue({ 'Pays': address.Country });
    this.sepaMandateForm.patchValue({ 'Adresse': address.Address });
    this.addresses = [];
  }

  formBack() {
    if (!this.isOffline) {
      this.router.navigate(['payment-means']);
    } else {
      this.isValidChangePage = true;
      this.router.navigate(['/purchase-orders-sign/' + this.orderId + '/' + this.orderHash]);
    }
  }

  private getInfoForm(): SepaForm {
    const sepaForm = new SepaForm();
    sepaForm.SupplierId = this.supplierId;
    sepaForm.ThirdPartyId = this.tiersId;
    sepaForm.PayerCompanyName = this.sepaMandateForm.controls.RaisonSociale.value;
    sepaForm.PayerStreetAddress = this.sepaMandateForm.controls.Adresse.value;
    sepaForm.PayerCity = this.sepaMandateForm.controls.Ville.value;
    sepaForm.PayerZipCode = this.sepaMandateForm.controls.Cp.value;
    sepaForm.PayerCountry = this.sepaMandateForm.controls.Pays.value;
    sepaForm.PayerLastName = this.sepaMandateForm.controls.Nom.value;
    sepaForm.PayerFirstName = this.sepaMandateForm.controls.Prenom.value;
    sepaForm.PayerAccountIBAN = this.sepaMandateForm.controls.Iban.value.replace(/\s/g, '');
    sepaForm.PayerAccountBIC = this.sepaMandateForm.controls.Bic.value;
    return sepaForm;
  }

  onLoadIframe() {
    this.loaderService.decreaseLoaderCount();
  }

  // event.data.event_id: redirect; event.data.status :[OK,CANCEL]
  @HostListener('window:message', ['$event'])
  public returnInfoSignSepa(event: any): void {
    if (event.data.event_id === 'redirect') {
      if (event.data.status === 'OK') {
        this.signatureSepaState = SignatureState.SIGNED;
        this.isValidChangePage = true;
        if (this.isOffline) {
          this.trackingService.pushEvent('financial-bdc_signature-confirmation');
          this.trackingService.pushPageViewGA4('financial_sepa_signature_confirmation');
        } else {
          this.trackingService.pushEvent('financial-sepa_signature-confirmation');
          this.trackingService.pushPageViewGA4('financial_sepa_signature_confirmation');
        }
      } else if (event.data.status === 'CANCEL') {
        this.signatureSepaState = SignatureState.SIGNATURE_REFUSED;
      }
      this.ngxSmartModalService.close('sepaSignIframeModal');
      if (!this.isOffline) {
        this.router.navigate(['/payment-means'],
          { queryParams: { sepaSignSupplierId: this.supplierId, sepaSignStatus: this.signatureSepaState } });
      }
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    if (this.signatureSepaState !== SignatureState.SIGNED) {
      event.returnValue = ' ';
      return ' ';
    }
  }

  onSepaFormExitConfirmed() {
    this.ngxSmartModalService.close('sepaFormExitModal');
    this.isValidChangePage = true;
    this.router.navigate([this.urlOkChangePage]);
  }

  getMessageError(control: FormControl, nameControl: string) {
    for (const propertyName in control.errors) {
      if (!this.loaderService.isLoading() && control.errors.hasOwnProperty(propertyName)) {
        return ValidationFormService.getValidatorErrorMessage(nameControl, propertyName, control.errors[propertyName]);
      }
    }
    return null;
  }

  goToTrainingCatalog() {
    window.open('https://pro.groupeseloger.com/formations', '_blank');
  }
}
